import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { useMutation } from "src/Hooks/useReactQuery";
import { addSequenceTags } from "src/services/sequences";

const useAddSequenceTag = (handleCancel, handleAddSequenceTagSuccess) => {
  const { t } = useTranslation("sequence");
  const showAlert = useSetRecoilState(alertState);

  const addSequenceTagMutation = useMutation({
    mutationFn: ({ data }) => addSequenceTags({ data }),
  });

  const submitData = ({ data }, callback) => {
    addSequenceTagMutation.mutate(
      { data },
      {
        onSuccess: async () => {
          showAlert({
            status: true,
            message: t("add_tag_modal.add_success"),
            type: "success",
          });
          handleCancel();
          if (handleAddSequenceTagSuccess) {
            await handleAddSequenceTagSuccess();
          }
        },
      }
    );
  };

  return {
    addSequenceTagMutation,
    submitData,
    isLoading: addSequenceTagMutation.isLoading,
    isError: addSequenceTagMutation.isError,
    error: addSequenceTagMutation.error,
  };
};

export default useAddSequenceTag;
